module.exports = __webpack_public_path__ + "static/img/sfz_icon.2a1e2f24.png";